import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import phytoImg from "../../assets/images/appImages/HYPERterapie.jpg";
import medecineImg from "../../assets/images/appImages/coran.jpg";
import hijamaImg from "../../assets/images/appImages/h.jpg";
import roqyaImg from "../../assets/images/appImages/roqya.jpg";
import Fade from 'react-reveal/Fade';
import { WHATSAPP_RDV_URL } from "../../utils/whatsapp";
type TabKey = "phyto" | "medecine" | "hijama" | "roqya";

interface Accompagnement {
  key: TabKey;
  navLabel: string;
  navIcon: string;
  categoryIcon: string;
  categoryColor: string; // couleur d'accent propre à la section
  title: string;
  image: string;
  imageAlt: string;
  quEstCe: string[];
  aQui: string[];
  deroulement: string[];
  precautions: string;
}

const ACCOMPAGNEMENTS: Accompagnement[] = [
  {
    key: "phyto",
    navLabel: "Phytothérapie",
    navIcon: "🌿",
    categoryIcon: "🌿",
    categoryColor: "#3f6b4a", // vert
    title: "Phytothérapie",
    image: phytoImg,
    imageAlt: "Bocaux et flacons de plantes en phytothérapie",
    quEstCe: [
      "La phytothérapie est l'utilisation des plantes à des fins de bien-être. Chez Fouta Bio, cette approche est fondée sur les usages traditionnels des plantes, leur qualité, les précautions nécessaires et les besoins spécifiques de chaque personne.",
    ],
    aQui: [
      "Toute personne souhaitant intégrer des plantes dans une démarche de bien-être global, en complément d'un suivi médical si nécessaire.",
    ],
    deroulement: [
      "Échange sur votre situation, vos habitudes et vos suivis en cours.",
      "Présentation des plantes adaptées, de leurs usages et de leurs précautions.",
      "Sélection de produits de qualité avec des conseils personnalisés.",
      "Suivi possible selon les besoins.",
    ],
    precautions:
      "Les plantes ne remplacent pas un traitement médical. Certaines présentent des contre-indications ou des interactions. Fouta Bio informe systématiquement des précautions à prendre.",
  },
  {
    key: "medecine",
    navLabel: "Médecine prophétique",
    navIcon: "📖",
    categoryIcon: "📖",
    categoryColor: "#3b5b7d", // bleu
    title: "Médecine prophétique",
    image: medecineImg,
    imageAlt: "Coran posé sur un tissu, médecine prophétique",
    quEstCe: [
      "La médecine prophétique (Tibb an-Nabawi) regroupe les pratiques et conseils de santé transmis dans la tradition du Prophète Muhammad ﷺ. Fouta Bio présente cette approche avec pédagogie, discernement et en vérifiant systématiquement les références.",
    ],
    aQui: [
      "Toute personne souhaitant mieux comprendre les pratiques de santé mentionnées dans la tradition prophétique, dans un cadre sérieux et documenté.",
    ],
    deroulement: [
      "Présentation claire et pédagogique des pratiques concernées.",
      "Vérification des sources religieuses et de leur fiabilité.",
      "Accompagnement adapté à la situation et aux convictions de la personne.",
      "Explication des limites et des complémentarités avec la médecine conventionnelle.",
    ],
    precautions:
      "La médecine prophétique ne remplace pas un suivi médical. Fouta Bio ne pose pas de diagnostic et ne prescrit pas de traitement médical.",
  },
  {
    key: "hijama",
    navLabel: "Hijama",
    navIcon: "🩸",
    categoryIcon: "🩸",
    categoryColor: "#b5432f", // rouge/orangé
    title: "Hijama",
    image: hijamaImg,
    imageAlt: "Séance de hijama, ventousothérapie",
    quEstCe: [
      "La Hijama est une pratique traditionnelle de ventousothérapie mentionnée dans la tradition prophétique. Elle consiste à poser des ventouses sur certaines zones du corps. Fouta Bio réalise cette pratique avec une attention particulière à l'écoute, à la préparation, à l'hygiène et à la sécurité.",
    ],
    aQui: [
      "Toute personne ayant préalablement échangé avec Ahmad Ba pour vérifier que la Hijama est appropriée à sa situation. Une séance n'est jamais proposée sans consultation préalable.",
    ],
    deroulement: [
      "Consultation préalable obligatoire pour évaluer l'adéquation de la pratique.",
      "Explication complète du déroulement, des sensations et des suites.",
      "Préparation rigoureuse du matériel à usage unique.",
      "Séance réalisée dans un espace propre et sécurisé.",
      "Conseils post-séance et suivi si nécessaire.",
    ],
    precautions:
      "La Hijama est contre-indiquée dans certaines situations (grossesse, troubles de la coagulation, certaines maladies). Une consultation préalable est systématiquement réalisée pour identifier ces situations.",
  },
  {
    key: "roqya",
    navLabel: "Roqya",
    navIcon: "🟡",
    categoryIcon: "🟡",
    categoryColor: "#a8842a", // doré/ocre
    title: "Roqya",
    image: roqyaImg,
    imageAlt: "Coran et fleurs, accompagnement spirituel Roqya",
    quEstCe: [
      "La Roqya est un accompagnement spirituel fondé sur la récitation de versets du Coran et des invocations authentiques (du'a). Fouta Bio propose une Roqya conforme aux principes islamiques, sans mise en scène alarmiste, sans intimidation et sans promesse de résultat garanti.",
    ],
    aQui: [
      "Toute personne souhaitant un accompagnement spirituel dans le cadre de sa démarche personnelle. La Roqya s'inscrit dans la dimension spirituelle de la personne et ne remplace pas un suivi médical ou psychologique.",
    ],
    deroulement: [
      "Échange préalable pour comprendre la demande et la situation.",
      "Présentation claire de ce qu'est la Roqya et de ce qu'elle n'est pas.",
      "Séance fondée sur la récitation du Coran et les invocations authentiques.",
      "Absence de mise en scène, de manipulation ou de discours alarmiste.",
      "Conseil d'un suivi médical ou psychologique si la situation le nécessite.",
    ],
    precautions:
      "La Roqya ne remplace pas l'évaluation ou le suivi d'un professionnel de santé lorsque cela est nécessaire. Fouta Bio oriente vers d'autres professionnels si la situation le demande.",
  },
];

function scrollToSection(key: string) {
  const el = document.getElementById(key);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export default function Accompagnements(): JSX.Element {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const sectionId = hash.replace("#", "");
    // Laisser le layout se peindre (images / sticky nav) avant le scroll
    const timer = window.setTimeout(() => scrollToSection(sectionId), 100);
    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <div className="accompagnements-page">
      {/* ===== Bandeau titre ===== */}
      <section className="accompagnements-hero text-center py-5">
        <Fade bottom>

            <p className="accompagnements-eyebrow text-uppercase small fw-semibold mb-2">
              Nos services
            </p>
            <h1 className="accompagnements-heading fw-bold mb-3">
              Nos accompagnements
            </h1>
            <p className="text-muted mx-auto accompagnements-intro">
              Chaque personne et chaque situation sont différentes. Fouta Bio prend le
              temps d'écouter et d'expliquer avant de proposer un accompagnement.
            </p>
        </Fade>
      </section>

      {/* ===== Barre de navigation (ancres) ===== */}
      <nav className="accompagnements-nav bg-white border-bottom sticky-top">
        <ul className="nav justify-content-center flex-nowrap overflow-auto px-2">
          {ACCOMPAGNEMENTS.map((item) => (
            <li className="nav-item" key={item.key}>
              <button
                type="button"
                onClick={() => scrollToSection(item.key)}
                className="accompagnements-tab nav-link d-flex align-items-center gap-2 px-3 py-3 border-0 bg-transparent"
              >
                <span aria-hidden="true">{item.navIcon}</span>
                {item.navLabel}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* ===== Sections empilées : Phytothérapie, Médecine prophétique, Hijama, Roqya ===== */}
      {ACCOMPAGNEMENTS.map((item, index) => {
        const imageFirst = index % 2 === 1;

        return (
          <section
            key={item.key}
            id={item.key}
            className="container py-5 accompagnement-section"
          >
            <div className="row g-5 align-items-start medecin">
              {/* Colonne texte */}
              <div
                className={`col-12 col-lg-6 order-2 ${
                  imageFirst ? "order-lg-2" : "order-lg-1"
                }`}
              >
                <div
                  className="accompagnements-category d-flex align-items-center gap-2 text-uppercase small fw-semibold mb-2"
                  style={{ color: item.categoryColor }}
                >
                  <span aria-hidden="true">{item.categoryIcon}</span>
                  Accompagnement
                </div>

                <h2 className="accompagnements-title fw-bold mb-4">
                  {item.title}
                </h2>

                <h6 className="text-uppercase small fw-bold text-muted mb-2">
                  Qu'est-ce que c'est ?
                </h6>
                {item.quEstCe.map((p, i) => (
                  <p key={i} className="accompagnements-text mb-4">
                    {p}
                  </p>
                ))}

                <h6 className="text-uppercase small fw-bold text-muted mb-2">
                  À qui cela peut-il s'adresser ?
                </h6>
                {item.aQui.map((p, i) => (
                  <p key={i} className="accompagnements-text mb-4">
                    {p}
                  </p>
                ))}

                <h6 className="text-uppercase small fw-bold text-muted mb-2">
                  Déroulement
                </h6>
                <ol className="accompagnements-text ps-3 mb-4">
                  {item.deroulement.map((step, i) => (
                    <li key={i} className="mb-2">
                      {step}
                    </li>
                  ))}
                </ol>

                <div className="accompagnements-precautions d-flex gap-2 p-3 mb-4 rounded">
                  <span aria-hidden="true">⚠️</span>
                  <p className="mb-0 small">
                    <strong>Précautions&nbsp;:</strong> {item.precautions}
                  </p>
                </div>
              </div>

              {/* Colonne image */}
              <div
                className={`col-12 col-lg-6 order-1 ${
                  imageFirst ? "order-lg-1" : "order-lg-2"
                }`}
              >
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  className="accompagnements-image img-fluid rounded shadow-sm w-100"
                />
              </div>
            </div>
          </section>
        );
      })}

      {/* ===== Bandeau final "Vous ne savez pas..." ===== */}
      <section className="accompagnements-banner text-center py-5">
        <h2 className="accompagnements-banner-title fw-bold mb-3">
          Vous ne savez pas quel accompagnement vous convient ?
        </h2>
        <p className="accompagnements-banner-text mx-auto mb-4">
          Contactez-nous. Nous prendrons le temps de comprendre votre situation
          avant de vous orienter.
        </p>
        
        <a  href={WHATSAPP_RDV_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="accompagnements-banner-btn btn fw-semibold px-4 py-2"
        >
          Poser une question sur WhatsApp
        </a>
      </section>
    </div>
  );
}